import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import CardItem from "@/pages/design/components/CardItem";
export default {
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    type: {
      type: String,
      default: 'textarea'
    },
    default: {
      type: String,
      default: ''
    }
  },
  components: {
    CardItem: CardItem
  },
  data: function data() {
    return {
      langList: []
    };
  },
  created: function created() {
    var _this = this;
    var langlist = localStorage.langList;
    langlist = JSON.parse(langlist);
    this.langList = langlist;

    // 根据localStorage初始化 titles
    if (langlist) {
      langlist.forEach(function (item) {
        if (typeof _this.value[item.langId] === 'undefined') {
          _this.$set(_this.value, item.langId, _this.default);
        }
      });
    }
  }
};